import React from 'react';
import { Modal } from 'react-bootstrap';
import './RemoveAgentModal.scss';

const RemoveAgentModal = ({ 
  show, 
  onHide, 
  onConfirm, 
  agentName, 
  isLoading, 
  actionType = 'remove' // 'remove' or 'cancel'
}) => {
  const isRemove = actionType === 'remove';
  const title = isRemove ? `Remove Agent - ${agentName}` : `Cancel Invitation - ${agentName}`;
  const description = isRemove 
    ? `Are you sure you want to remove ${agentName} from your workspace?`
    : `Are you sure you want to cancel the invitation for ${agentName}?`;
  const confirmButtonText = isRemove ? 'Remove' : 'Cancel Invitation';

  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      backdrop="static"
      keyboard={!isLoading}
      className="remove-agent-modal-wrapper"
      dialogClassName="custom-modal-dialog"
    >
      <div className="remove-agent-modal">
        {/* Close Button */}
        <button 
          className="modal-close-btn" 
          onClick={onHide}
          disabled={isLoading}
          aria-label="Close"
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path 
              d="M15 5L5 15M5 5L15 15" 
              stroke="#737C8A" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </button>

        {/* Content Container */}
        <div className="modal-content-container">
          {/* Warning Icon */}
          <div className="warning-icon-container">
            <div className="warning-icon">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path 
                  d="M7.5 4.5V7.5M7.5 10.5H7.505M13.5 7.5C13.5 10.8137 10.8137 13.5 7.5 13.5C4.18629 13.5 1.5 10.8137 1.5 7.5C1.5 4.18629 4.18629 1.5 7.5 1.5C10.8137 1.5 13.5 4.18629 13.5 7.5Z" 
                  stroke="#E74C3C" 
                  strokeWidth="1.25" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>

          {/* Text Content */}
          <div className="modal-text-content">
            <div className="modal-title-section">
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-description-section">
              <p className="modal-description">{description}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="modal-actions">
          <button 
            className="cancel-button" 
            onClick={onHide}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button 
            className="remove-button" 
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="loading-spinner">
                <div className="spinner"></div>
                <span>{isRemove ? 'Removing...' : 'Cancelling...'}</span>
              </div>
            ) : (
              confirmButtonText
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveAgentModal;